module.exports = __webpack_public_path__ + "public/SiteIcons/heart.png?cf6011b4";